import { useSyncExternalStore } from 'react';
import { onlineManager } from '@tanstack/react-query';

/** Single source of truth for online state (TanStack's onlineManager already
 *  tracks navigator.onLine + online/offline events). */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(
    (cb) => onlineManager.subscribe(cb),
    () => onlineManager.isOnline(),
    () => true, // SSR/first paint: assume online
  );
}
